webpackJsonp([111826146443291],{

/***/ 1375:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CensusAppointmentAssignmentFilter","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"assignedOnly","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"assignmentStatus","type":{"kind":"ENUM","name":"CensusAssignmentStatus","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-census-appointment-assignment-filter-64602e026e0c5835207d.js